import { Flex, IconButton, IconName, ProductColor, Tooltip } from '@aloft/toolkit-sui';

type Props = {
  id?: string;
  label: string;
  icon: IconName;
  isSelected: boolean;
  formItem?: boolean;
  onClick: () => void;
};

export const Tkv2ReferenceBarItem = ({ id, label, icon, isSelected, formItem, onClick }: Props) => {
  let backgroundColor: ProductColor = 'surface1';
  let borderColor: ProductColor = 'transparent';
  let iconColor: ProductColor = 'textTertiary';
  if (isSelected) {
    if (formItem) {
      backgroundColor = 'selected5';
      borderColor = 'surfaceAccent10';
      iconColor = 'surfaceAccent10';
    } else {
      backgroundColor = 'selected4';
      borderColor = 'surfaceAccent4';
      iconColor = 'surfaceAccent4';
    }
  } else if (formItem) {
    iconColor = 'surfaceAccent10';
  }
  return (
    <Flex
      backgroundColor={backgroundColor}
      borderRightWidth=".25rem"
      borderStyle="solid"
      borderRightColor={borderColor}
      width="100%"
      alignItems="center"
      justifyContent="center"
    >
      <Tooltip label={label} placement="left">
        <IconButton
          id={id}
          ariaLabel={label}
          icon={icon}
          iconColor={iconColor}
          iconSize="lg"
          onClick={onClick}
          variant="tertiary"
          size="md"
        />
      </Tooltip>
    </Flex>
  );
};
